<div>
  <input
    #propertyName="ngModel"
    id="datePicker-{{ name }}"
    class="form-control"
    (keydown)="onKeyDown($event)"
    type="text"
    [name]="name"
    [maxlength]="maxLength"
    [(ngModel)]="model"
    [required]="isRequired"
    [disabled]="isDisabled"
    placeholder="Select a date..."
    numericOnly
    autocomplete="off"
  />
  <div validationErrors [for]="propertyName.control" [errorEmitter]="errorEmitter"></div>
</div>
